<div class="row">
  <div class="col-sm-12">
    <app-card
              [title]="'global.archive'|translate">
      <app-grid [grid]="grid"></app-grid>
      <button class="btn btn-primary ripple light pull-right my-3" (click)="goToFabricCollectionOverview()" type="button">{{'admin.fabric-collection.overview.button'|translate}}</button>
    </app-card>
  </div>
</div>

<ng-template #dealerPriceTemp let-row="row" let-value="value" let-column="column">
  {{((row.dealerPrice) ? row.dealerPrice : row.customerPrice)| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}
</ng-template>
<ng-template #customerPriceTemp let-row="row" let-value="value" let-column="column">
  {{row.customerPrice| BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}
</ng-template>

<app-modal-basic #readdModel >
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'Fabric Collection'} }}</h4>
    <button type="button" class="close basic-close" (click)="readdModel.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <span [innerHTML]="fabricCollectionName"></span> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-default ripple me-4" (click)="readdModel.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="readd()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>
